<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="onClose()">
  <div class="relative w-full max-w-xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-[0_24px_70px_rgba(15,23,42,0.25)] border border-slate-100/60 dark:border-slate-700 overflow-hidden animate-fade-in-up" (click)="$event.stopPropagation()">
    <div class="absolute top-0 left-[10%] w-[80%] h-1.5 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 rounded-b-full"></div>
    <div *ngIf="isLoading() || isSaving()" class="absolute inset-0 z-50 bg-white/70 dark:bg-slate-900/70 backdrop-blur-sm flex items-center justify-center">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="px-6 md:px-8 pt-8 pb-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <span class="w-11 h-11 rounded-2xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center">
          <span class="material-icons">ev_station</span>
        </span>
        <div>
          <h2 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ isEdit ? 'แก้ไขชนิดหัวชาร์จ' : 'เพิ่มชนิดหัวชาร์จ' }}</h2>
          <p class="text-xs text-slate-400 mt-0.5">รหัสที่ใช้ได้: ac, dc, ac_dc</p>
        </div>
      </div>
      <button type="button" (click)="onClose()" class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 md:p-8 space-y-4">
      <div *ngIf="isEdit" class="flex items-center gap-2 px-4 py-3 rounded-2xl bg-slate-50 dark:bg-slate-800 text-xs text-slate-500">
        <span class="material-icons text-amber-500 text-[18px]">info</span>
        <span>ID: <b class="text-slate-700 dark:text-slate-200">{{ formData.id }}</b></span>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-500 mb-2">รหัส <span class="text-rose-500">*</span></label>
        <select [ngModel]="formData.code" (ngModelChange)="onCodeChange($event)"
          class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200">
          <option *ngFor="let opt of codeOptions" [ngValue]="opt.value">{{ opt.label }} ({{ opt.value }})</option>
        </select>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-500 mb-2">ชื่อ (TH) <span class="text-rose-500">*</span></label>
        <input [(ngModel)]="formData.name" placeholder="เช่น AC (ช้า)"
          class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-500 mb-2">Name EN</label>
        <input [(ngModel)]="formData.nameEn" placeholder="เช่น AC Slow"
          class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-500 mb-2">คำอธิบาย</label>
        <textarea [(ngModel)]="formData.description" rows="2" placeholder="รายละเอียดสั้น ๆ"
          class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-2">ลำดับแสดง</label>
          <input type="number" [(ngModel)]="formData.sortOrder"
            class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
        </div>
        <div class="flex items-end">
          <label class="inline-flex items-center gap-2 cursor-pointer px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 w-full">
            <input type="checkbox" [(ngModel)]="formData.active" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <span class="text-sm font-bold text-slate-600 dark:text-slate-300">Active</span>
          </label>
        </div>
      </div>
    </div>

    <div class="px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col-reverse sm:flex-row justify-between gap-3 bg-slate-50/50 dark:bg-slate-900/50">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
      <button type="button" (click)="onClose()"
        class="px-5 py-3 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:bg-slate-50 dark:hover:bg-slate-800 cursor-pointer">
        ยกเลิก
      </button>
      <button type="button" (click)="onSave()" [disabled]="isSaving()"
        class="px-6 py-3 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none disabled:opacity-50 transition-all cursor-pointer flex items-center justify-center gap-2">
        <span class="material-icons text-[18px]">save</span>
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.EvConnectorType"
  [entityId]="itemId"
  title="ประวัติประเภทหัวชาร์จ EV"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
